// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","jobVaultHeader":"_2icIT3qT3TWUUTRY0iJrQ8","jobIcon":"tpzoii4pVgHKzVjGsR-Nq","jobLink":"_3TpxGeqeqYJky-uO7-W1Tq"};